<section class="ced-ni" aria-label="Itens da nota">
  <div class="section-title">
    <mat-icon>receipt_long</mat-icon>
    <span>Itens da nota</span>
    @if (!carregando && !erro) {
      <span class="status-badge badge-cinza">{{ qtdItensNota }}</span>
      @if (qtdItensSemVinculo) {
        <span class="status-badge badge-amarelo ced-ni-sem-vinculo">
          <mat-icon class="material-symbols-outlined">link_off</mat-icon>
          {{ qtdItensSemVinculo }} sem vínculo
        </span>
      }
    }
    @if (ocultarQuantidades) {
      <span class="ced-ni-oculto">Quantidades ocultas durante a conferência cega</span>
    }
  </div>

  @if (erro) {
    <app-alert-card type="warning" icon="error" title="Itens indisponíveis.">{{ erro }}</app-alert-card>
  } @else if (carregando) {
    <div class="ced-ni-carregando">
      <mat-progress-spinner mode="indeterminate" diameter="28"></mat-progress-spinner>
    </div>
  } @else {
    <div class="ced-ni-tabela" [class.ced-ni-tabela--sem-qtd]="ocultarQuantidades" role="table" aria-label="Itens da nota">
      <div class="ced-ni-linha ced-ni-linha--cabecalho" role="row">
        <span role="columnheader">Nº</span>
        <span role="columnheader">Produto na NF</span>
        @if (!ocultarQuantidades) { <span role="columnheader" class="ced-ni-num">Qtd.</span> }
        <span role="columnheader" class="ced-ni-num">Valor unit.</span>
        <span role="columnheader">Item do pedido</span>
      </div>

      @for (grupo of grupos; track grupo.chave) {
        <div class="ced-ni-grupo" role="rowgroup">
          <div class="ced-ni-grupo-titulo"
            [class.ced-ni-grupo-titulo--atual]="grupo.idCompra !== null && grupo.idCompra === idCompraAtual"
            [class.ced-ni-grupo-titulo--sem-vinculo]="!grupo.idCompra">
            <mat-icon class="material-symbols-outlined">{{ grupo.idCompra ? 'shopping_cart' : 'link_off' }}</mat-icon>
            <span class="ced-ni-grupo-nome">{{ grupo.titulo }}</span>
            @if (grupo.idCompra !== null && grupo.idCompra === idCompraAtual) { <span class="ced-ni-grupo-meta">· este pedido</span> }
            @if (grupo.nomeEtapa) { <span class="ced-ni-grupo-meta">· {{ grupo.nomeEtapa }}</span> }
            <span class="ced-ni-grupo-meta">· {{ grupo.linhas.length }} {{ grupo.linhas.length === 1 ? 'linha' : 'linhas' }}</span>
          </div>
          @for (linha of grupo.linhas; track linha.chave) {
            <div class="ced-ni-linha" role="row">
              <span class="ced-ni-numero" role="cell">{{ linha.numeroItem }}</span>
              <span class="ced-ni-produto" role="cell">
                <span class="ced-ni-descricao" [attr.title]="linha.descricao">{{ linha.descricao }}</span>
                @if (linha.codigoEmitente) { <span class="ced-ni-codigo">Cód. {{ linha.codigoEmitente }}</span> }
              </span>
              @if (!ocultarQuantidades) {
                <span class="ced-ni-num" role="cell">
                  <span class="ced-ni-rotulo-mobile">Qtd.</span>
                  {{ linha.quantidade !== null ? (linha.quantidade | abnt: 'quantidade') : '—' }}{{ linha.unidade ? ' ' + linha.unidade : '' }}
                </span>
              }
              <span class="ced-ni-num" role="cell">
                <span class="ced-ni-rotulo-mobile">Valor unit.</span>
                {{ linha.valorUnitario !== null ? (linha.valorUnitario | abnt: 'preco') : '—' }}
              </span>
              <span class="ced-ni-pedido" role="cell">
                @if (linha.itemPedido) {
                  <span class="ced-ni-pedido-nome" [attr.title]="linha.itemPedido">{{ linha.itemPedido }}</span>
                  @if (linha.quantidadeVinculada !== null && !ocultarQuantidades) {
                    <span class="ced-ni-codigo">
                      Vinculado {{ linha.quantidadeVinculada | abnt: 'quantidade' }}{{ linha.unidadePedido ? ' ' + linha.unidadePedido : '' }}
                    </span>
                  }
                } @else {
                  <span class="status-badge badge-cinza">Sem vínculo</span>
                }
              </span>
            </div>
          }
        </div>
      } @empty {
        <div class="ced-ni-vazio">A nota não tem itens.</div>
      }
    </div>
  }
</section>
